import type { ContractOtherCostItemData, ProjectMethodologyEnum, ConstructionTypeData } from 'gql/graphql';
import { ContractOtherStatusEnum } from 'gql/graphql';

import type { ICellRendererParams } from 'ag-grid-community';
import type { FC } from 'react';

import { ContractOthersRowMenu } from '../ContractOthersRowMenu';

interface IMenuCellRenderer extends ICellRendererParams<ContractOtherCostItemData> {
    constructionTypes: ConstructionTypeData[];
    contractId: number;
    constructionTypeId: number;
    onOperationSuccess: (id?: number) => void;
    hasWorkOrders: boolean;
    methodology: ProjectMethodologyEnum;
    costRounding: number;
}

export enum HeaderIds {
    HEADER_OTHERS = 'header_others',
    HEADER_LIMITS = 'header_limits',
}

export const ContractOtherStatusTitles = {
    [ContractOtherStatusEnum.AdditionalCondition]: 'Условие ДС',
    [ContractOtherStatusEnum.ContractCondition]: 'Условие договора',
    [ContractOtherStatusEnum.NewRecord]: 'Новая запись',
    [ContractOtherStatusEnum.Draft]: 'Черновик',
};
export const cellClass = ({ data }: any) =>
    [HeaderIds.HEADER_OTHERS, HeaderIds.HEADER_LIMITS].includes(data.id) ? 'sub-header' : '';

export const notSubHeaderRow = (row: any) => ![HeaderIds.HEADER_OTHERS, HeaderIds.HEADER_LIMITS].includes(row.id);

export const MenuCellRenderer: FC<IMenuCellRenderer> = (props) => {
    const {
        data,
        constructionTypeId,
        contractId,
        constructionTypes,
        onOperationSuccess,
        hasWorkOrders,
        methodology,
        costRounding,
    } = props;

    return notSubHeaderRow(data) ? (
        <ContractOthersRowMenu
            row={data}
            onOperationSuccess={onOperationSuccess}
            constructionTypes={constructionTypes}
            constructionTypeId={constructionTypeId}
            contractId={contractId}
            hasWorkOrders={hasWorkOrders}
            methodology={methodology}
            costRounding={costRounding}
        />
    ) : (
        <span />
    );
};

MenuCellRenderer.displayName = 'MenuCellRenderer';
